export const agentRequests = {
  page: {
    filters: {
      accommodation: "Unterkunft",
      type: "Typ",
    },
    subtitle: "Was Ihre Gäste über den Agenten angefragt haben.",
    clearFilters: "Filter löschen",
    loadMore: "Mehr anzeigen",
    empty: "Noch keine Anfragen.",
    emptyFiltered: "Keine Anfragen mit diesen Filtern.",
    columns: {
      type: "Art",
      guest: "Gast",
      asks: "Anliegen",
      channel: "Kanal",
      status: "Status",
      when: "Wann",
      amount: "Betrag",
    },
  },
  // La columna Importe: en qué quedó el cobro de cada solicitud.
  amount: {
    paid: "Bezahlt",
    awaiting: "Wartet auf Zahlung",
    property: "Vor Ort zu zahlen",
    void: "Nicht berechnet",
    quote: "Angeboten",
  },
  common: {
    title: "Anfragen an die KI-Rezeption",
  },
  widget: {
    iaBadge: "KI",
    subtitle: "Was Ihre Gäste über den Agenten angefragt haben.",
    todayOn: "Nur von heute",
    todayOff: "Nur heutige Anfragen anzeigen",
    today: "Heute",
    entersToday: "Reist heute an",
    entersTodayTitle: "Diese Buchung reist heute an",
    test: "Test",
    approve: "Genehmigen",
    otherTime: "Andere Uhrzeit",
    prioritize: "Priorisieren",
    reject: "Ablehnen",
    dismiss: "Aus dem Dashboard entfernen",
    loading: "Anfragen werden geladen…",
    empty: "Noch keine Anfragen.",
    emptySub: "Wenn ein Gast einen späten Check-out, einen frühen Check-in oder zusätzliche Nächte anfragt, erscheint das hier.",
    viewAll: "Alle Anfragen ansehen",
    entryTime: "Check-in-Zeit",
    cancel: "Abbrechen",
    rejectIrreversible: "Diese Aktion kann nicht rückgängig gemacht werden.",
    modal: {
      approveTitle: "Anfrage genehmigen?",
      approveTimeTitle: "Zu einer anderen Uhrzeit genehmigen?",
      tentativeTitle: "Diese Anreise priorisieren?",
      rejectTitle: "Anfrage ablehnen?",
      defaultTitle: "Bestätigen?",
      approveText: "Sie genehmigen gleich den frühen Check-in für",
      approveTimeText: "Sie bestätigen den Check-in zur festgelegten Uhrzeit für",
      tentativeText: "Wir sagen dem Gast, dass Sie alles tun, damit es bis dahin bereit ist, es aber vom vorherigen Check-out und der Reinigung abhängt. Gesendet an",
      rejectText: "Sie lehnen gleich den frühen Check-in ab für",
      defaultText: "Bestätigen für",
      approveCta: "Ja, genehmigen",
      approveTimeCta: "Uhrzeit bestätigen",
      tentativeCta: "Ja, benachrichtigen",
      rejectCta: "Ja, ablehnen",
      defaultCta: "Bestätigen",
    },
  },
  drawer: {
    close: "Schließen",
    allAccommodations: "Alle Unterkünfte",
    allTypes: "Alle Typen",
    today: "Heute",
    yesterday: "Gestern",
    from: "Von",
    to: "Bis",
    clear: "Zurücksetzen",
    writeWhatsapp: "Über WhatsApp schreiben",
    noMessages: "Keine gespeicherten Nachrichten für diesen Chat.",
    pause: "Pause",
    play: "Abspielen",
    downloadMp3: "MP3 herunterladen",
    viewReservation: "Buchung ansehen",
    loading: "Wird geladen…",
    emptyFiltered: "Keine Anfragen entsprechen diesen Filtern.",
    end: "Keine weiteren Anfragen.",
    features: {
      early: "Früher Check-in",
      late: "Später Check-out",
      extend: "Aufenthalt verlängern",
      invoice: "Rechnung",
      handoff: "Aktion erforderlich",
      callMessage: "Anrufnachrichten",
    },
    channels: {
      call: "Anruf",
    },
  },
  box: {
    rooms: "{count} Zimmer | {count} Zimmer",
    nights: "{count} Nacht | {count} Nächte",
    guests: "{count} Gast | {count} Gäste",
    earlyRequestedTitle: "Früher Check-in angefragt",
    arrivalRequestedTitle: "Ankunftszeit angefragt",
    early: "Früh",
    arrives: "Ankunft",
  },
};
